import * as Sentry from '@sentry/react';

// Initialize Sentry for frontend monitoring and session replay
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "https://226e0a1adcff47d1166628b1bff2d62e@o4509641852321792.ingest.us.sentry.io/4510116574199808",

  // Environment for better filtering in Sentry
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT || 'development',

  // Enable automatic user IP collection and other PII data
  sendDefaultPii: true,

  integrations: [
    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),

    // Session replay for user interaction recording
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),

    // Send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Performance Monitoring - Tracing
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '1.0'),

  // Set tracePropagationTargets to control distributed tracing
  // This connects frontend traces to backend traces
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/(dev|qa|demo)?\.?api\.entradasegura\.com\.br/,
  ],

  // Session Replay sample rates
  replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0.1'), // 10% of sessions
  replaysOnErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0'), // 100% when errors occur
});

export default Sentry;
